import React, { FC } from 'react';
import { FlowDiffHintContainer } from '../NewVerificationTab.styles';

interface FlowDiffHintProps {
  /** Which flow the value belongs to — 'Manual Processing' or 'Final Review' (the OTHER flow). */
  label: string;
  /** The other flow's formatted value. When empty/undefined, nothing renders. */
  value: string | undefined;
  testId: string;
}

/**
 * Small red inline text shown next to a top-section / account-controls field when the OTHER
 * verification flow (Manual vs Final) has a different saved value than the one displayed. Names
 * the other flow and its value, e.g. "Manual Processing: KNOX-12345".
 */
export const FlowDiffHint: FC<FlowDiffHintProps> = ({ label, value, testId }) => {
  if (!value) {
    return null;
  }

  return (
    <FlowDiffHintContainer data-testid={testId}>
      {label}: {value}
    </FlowDiffHintContainer>
  );
};
